module.exports = __webpack_public_path__ + "static/media/HOMEPAGE_ICONS_SEARCH.7869ed6b.svg";